import { render, staticRenderFns } from "./ScrollUpBtn.vue?vue&type=template&id=3d307568&scoped=true&"
import script from "./ScrollUpBtn.vue?vue&type=script&lang=js&"
export * from "./ScrollUpBtn.vue?vue&type=script&lang=js&"
import style0 from "./ScrollUpBtn.vue?vue&type=style&index=0&id=3d307568&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d307568",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
